document.addEventListener('DOMContentLoaded', function () {

    // Localizar elementos
    var btnAgregarColaborador = document.querySelectorAll('article[data-modal="modalAgregarColaborador"]');
    var modalAgregarColaborador = document.querySelector('#modalAgregarColaborador');

    // Si el modal no existe o no hay triggers en esta página, salir
    if (!modalAgregarColaborador || !btnAgregarColaborador || btnAgregarColaborador.length === 0) {
        return;
    }

    // Abrir modal / set contexto
    btnAgregarColaborador.forEach(function (boton) {
        boton.addEventListener('click', function () {

            var accion = this.getAttribute('data-accion');
            var origen = this.getAttribute('data-origen');
            var area = this.getAttribute('data-area');

            var inputOrigen = modalAgregarColaborador.querySelector('input[name="origenModal"]');
            var inputAccion = modalAgregarColaborador.querySelector('input[name="accion"]');
            var inputArea = modalAgregarColaborador.querySelector('input[id="filtroArea"]');

            if (!inputOrigen || !inputAccion || !inputArea) {
                console.warn('Faltan inputs ocultos en el modal: origenModal / accion / filtroArea');
                return;
            }

            inputOrigen.value = origen || '';
            inputAccion.value = accion || '';
            inputArea.value = area || '';

            modalAgregarColaborador.classList.add('modal--show');
        });
    });

    // Delegación de eventos:
    // funciona aunque los .colaborador se agreguen después por AJAX
    modalAgregarColaborador.addEventListener('click', function (e) {
        var colaborador = closest(e.target, '.colaborador');
        if (!colaborador) return;

        seleccionarColaborador(colaborador, modalAgregarColaborador);
    });

    function seleccionarColaborador(elemento, modal) {
        var idColaborador = elemento.getAttribute("data-id");
        var nombreColaborador = elemento.getAttribute("data-nombre");
        var cargoColaborador = elemento.getAttribute("data-cargo");

        var img = elemento.querySelector("img.imgColaborador");
        var srcImagen = img ? img.getAttribute("src") : "";

        var inputOrigenEl = modal.querySelector('input[name="origenModal"]');
        var inputAccionEl = modal.querySelector('input[name="accion"]');

        if (!inputOrigenEl || !inputAccionEl) {
            console.warn("Faltan inputs ocultos en el modal");
            return;
        }

        var inputOrigen = inputOrigenEl.value;
        var inputAccion = inputAccionEl.value;

        if (!inputOrigen || !inputAccion || !idColaborador) {
            console.warn("Faltan datos: origen/accion/idColaborador");
            return;
        }

        var selectorDestino = '#' + inputOrigen + ' article[data-accion="' + inputAccion + '"]';
        var articuloColaborador = document.querySelector(selectorDestino);

        if (!articuloColaborador) {
            console.warn("No se encontró el artículo destino:", selectorDestino);
            return;
        }

        var roleNode = articuloColaborador.querySelector('.cardPersonalRole');
        var roleColaborador = roleNode ? roleNode.textContent : '';

        var inputName = 'idMecanico';
        if (inputAccion === 'agregarOperario') inputName = 'idOperario';
        if (inputAccion === 'agregarEmpacador') inputName = 'idEmpacador';

        articuloColaborador.innerHTML =
            '<input type="hidden" name="' + inputName + '" value="' + idColaborador + '">' +
            '<div class="cardPersonalAvatar">' +
                (srcImagen ? '<img class="imgColaborador" src="' + srcImagen + '" alt="colaborador">' : '') +
            '</div>' +
            '<div class="cardPersonalBody">' +
                '<p class="cardPersonalRole">' + escapeHtml(roleColaborador || cargoColaborador || '') + '</p>' +
                '<p class="cardPersonalName">' + escapeHtml(nombreColaborador || '') + '</p>' +
            '</div>';

        modal.classList.remove("modal--show");
        modal.querySelector('#filtroNombre').value = '';

    }

    function escapeHtml(str) {
        str = str == null ? '' : String(str);
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function closest(el, selector) {
        while (el && el.nodeType === 1) {
            if (matches(el, selector)) return el;
            el = el.parentElement;
        }
        return null;
    }

    function matches(el, selector) {
        var p = Element.prototype;
        var fn = p.matches || p.webkitMatchesSelector || p.msMatchesSelector;
        if (!fn) return false;
        return fn.call(el, selector);
    }

});